import { Box, SxProps, Theme, useTheme } from '@mui/material';
import { FC, ReactNode } from 'react';

interface Props {
  children?: ReactNode;
  sx?: SxProps<Theme>;
}

const BenchmarkDataCell: FC<Props> = ({ children, sx }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        flex: 1,
        py: theme.spacing(2),
        px: theme.spacing(2),
        mx: theme.spacing(-2),
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};

export default BenchmarkDataCell;
